import frRoutes from '@/config/next/routes/fr.json';
import globalRoutes from '@/config/next/routes/global.json';

export const routes = {
  ...globalRoutes,
  ...frRoutes,
};
